/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { AvailabilitiesBulkRetrievalResults } from '../models/availabilities-bulk-retrieval-results';
import { availabilitiesPatch } from '../fn/menu-availability/availabilities-patch';
import { AvailabilitiesPatch$Params } from '../fn/menu-availability/availabilities-patch';
import { AvailabilitiesPatchResponse } from '../models/availabilities-patch-response';
import { AvailabilityRetrievalResult } from '../models/availability-retrieval-result';
import { catalogEntriesAvailabilityGet } from '../fn/menu-availability/catalog-entries-availability-get';
import { CatalogEntriesAvailabilityGet$Params } from '../fn/menu-availability/catalog-entries-availability-get';
import { catalogEntriesCatalogEntryIdAvailabilitiesGet } from '../fn/menu-availability/catalog-entries-catalog-entry-id-availabilities-get';
import { CatalogEntriesCatalogEntryIdAvailabilitiesGet$Params } from '../fn/menu-availability/catalog-entries-catalog-entry-id-availabilities-get';
import { PaginatedAvailabilityResult } from '../models/paginated-availability-result';
import { storesStoreIdCatalogEntryAvailabilitiesBulkRetrievePost } from '../fn/menu-availability/stores-store-id-catalog-entry-availabilities-bulk-retrieve-post';
import { StoresStoreIdCatalogEntryAvailabilitiesBulkRetrievePost$Params } from '../fn/menu-availability/stores-store-id-catalog-entry-availabilities-bulk-retrieve-post';

@Injectable({ providedIn: 'root' })
export class MenuAvailabilityService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `storesStoreIdCatalogEntryAvailabilitiesBulkRetrievePost()` */
  static readonly StoresStoreIdCatalogEntryAvailabilitiesBulkRetrievePostPath = '/stores/{storeId}/catalog-entry-availabilities/bulk-retrieve';

  /**
   * Bulk retrieves all availabilities for a given set of Catalog entries for a given store.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `storesStoreIdCatalogEntryAvailabilitiesBulkRetrievePost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  storesStoreIdCatalogEntryAvailabilitiesBulkRetrievePost$Response(params: StoresStoreIdCatalogEntryAvailabilitiesBulkRetrievePost$Params, context?: HttpContext): Observable<StrictHttpResponse<AvailabilitiesBulkRetrievalResults>> {
    return storesStoreIdCatalogEntryAvailabilitiesBulkRetrievePost(this.http, this.rootUrl, params, context);
  }

  /**
   * Bulk retrieves all availabilities for a given set of Catalog entries for a given store.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `storesStoreIdCatalogEntryAvailabilitiesBulkRetrievePost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  storesStoreIdCatalogEntryAvailabilitiesBulkRetrievePost(params: StoresStoreIdCatalogEntryAvailabilitiesBulkRetrievePost$Params, context?: HttpContext): Observable<AvailabilitiesBulkRetrievalResults> {
    return this.storesStoreIdCatalogEntryAvailabilitiesBulkRetrievePost$Response(params, context).pipe(
      map((r: StrictHttpResponse<AvailabilitiesBulkRetrievalResults>): AvailabilitiesBulkRetrievalResults => r.body)
    );
  }

  /** Path part for operation `catalogEntriesAvailabilityGet()` */
  static readonly CatalogEntriesAvailabilityGetPath = '/catalog-entries/availability';

  /**
   * Gets a single catalog entry's availability.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `catalogEntriesAvailabilityGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  catalogEntriesAvailabilityGet$Response(params: CatalogEntriesAvailabilityGet$Params, context?: HttpContext): Observable<StrictHttpResponse<AvailabilityRetrievalResult>> {
    return catalogEntriesAvailabilityGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets a single catalog entry's availability.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `catalogEntriesAvailabilityGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  catalogEntriesAvailabilityGet(params: CatalogEntriesAvailabilityGet$Params, context?: HttpContext): Observable<AvailabilityRetrievalResult> {
    return this.catalogEntriesAvailabilityGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<AvailabilityRetrievalResult>): AvailabilityRetrievalResult => r.body)
    );
  }

  /** Path part for operation `availabilitiesPatch()` */
  static readonly AvailabilitiesPatchPath = '/availabilities';

  /**
   * path catalog entry's availability.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `availabilitiesPatch()` instead.
   *
   * This method doesn't expect any request body.
   */
  availabilitiesPatch$Response(params: AvailabilitiesPatch$Params, context?: HttpContext): Observable<StrictHttpResponse<AvailabilitiesPatchResponse>> {
    return availabilitiesPatch(this.http, this.rootUrl, params, context);
  }

  /**
   * path catalog entry's availability.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `availabilitiesPatch$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  availabilitiesPatch(params: AvailabilitiesPatch$Params, context?: HttpContext): Observable<AvailabilitiesPatchResponse> {
    return this.availabilitiesPatch$Response(params, context).pipe(
      map((r: StrictHttpResponse<AvailabilitiesPatchResponse>): AvailabilitiesPatchResponse => r.body)
    );
  }

  /** Path part for operation `catalogEntriesCatalogEntryIdAvailabilitiesGet()` */
  static readonly CatalogEntriesCatalogEntryIdAvailabilitiesGetPath = '/catalog-entries/{catalogEntryId}/availabilities';

  /**
   * Get availability information for a Catalog Entry
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `catalogEntriesCatalogEntryIdAvailabilitiesGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  catalogEntriesCatalogEntryIdAvailabilitiesGet$Response(params: CatalogEntriesCatalogEntryIdAvailabilitiesGet$Params, context?: HttpContext): Observable<StrictHttpResponse<PaginatedAvailabilityResult>> {
    return catalogEntriesCatalogEntryIdAvailabilitiesGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Get availability information for a Catalog Entry
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `catalogEntriesCatalogEntryIdAvailabilitiesGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  catalogEntriesCatalogEntryIdAvailabilitiesGet(params: CatalogEntriesCatalogEntryIdAvailabilitiesGet$Params, context?: HttpContext): Observable<PaginatedAvailabilityResult> {
    return this.catalogEntriesCatalogEntryIdAvailabilitiesGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<PaginatedAvailabilityResult>): PaginatedAvailabilityResult => r.body)
    );
  }

}
